const mutations = {
  updateCompanies(state, { companies }) {
    state.companies = companies;
  },
  updateTrainingProviders(state, { trainingProviders }) {
    state.trainingProviders = trainingProviders;
  },
  setEntities(state, { items, key }) {
    state[key] = items;
  },
};

const {
  updateCompanies,
  updateTrainingProviders,
} = mutations;

export {
  updateCompanies,
  updateTrainingProviders,
};

export default mutations;
